import { Box, Typography, Collapse, CircularProgress } from "@mui/material";
import { useState } from "react";
import { UserRegisterForm } from "../../components/auth/UserRegisterForm";
import { ClientCreateForm } from "../../components/auth/ClientCreateForm";
import { useNavigate } from "react-router-dom";
import { useSnackbar } from "notistack";
import { LG } from "../../styles/liquidGlass";

export default function Register() {
    const [step, setStep] = useState<"user" | "client">("user");
    const [userData, setUserData] = useState<{ nombre: string; apellido: string } | null>(null);

    const [registeringUser, setRegisteringUser] = useState(false);
    const [savingClient, setSavingClient] = useState(false);

    const navigate = useNavigate();
    const { enqueueSnackbar } = useSnackbar();

    const showOverlay = registeringUser || savingClient;
    const overlayText = step === "user" ? "Creando tu cuenta" : "Guardando cliente";

    return (
        <Box sx={{ maxWidth: 420, mx: "auto", mt: 4, mb: 10 }}>
            <Box
                sx={{
                    p: 3,
                    background: LG.color.surfaceStrong,
                    backdropFilter: LG.blur,
                    WebkitBackdropFilter: LG.blur,
                    border: `1px solid ${LG.color.border}`,
                    borderRadius: LG.radius.lg,
                    boxShadow: LG.shadow.md,
                    position: "relative",
                    overflow: "hidden",
                }}
            >
                {showOverlay && (
                    <Box
                        sx={{
                            position: "absolute",
                            inset: 0,
                            zIndex: 10,
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: 2,
                            background: LG.color.surfaceStrong,
                            backdropFilter: LG.blur,
                            WebkitBackdropFilter: LG.blur,
                        }}
                    >
                        <CircularProgress size={28} sx={{ color: LG.color.text }} />
                        <Typography
                            sx={{
                                fontFamily: "inherit",
                                fontSize: "0.875rem",
                                fontWeight: 600,
                                color: LG.color.text,
                            }}
                        >
                            {overlayText}
                        </Typography>
                    </Box>
                )}

                <Typography
                    sx={{
                        fontSize: 24,
                        fontWeight: 700,
                        fontFamily: "inherit",
                        color: LG.color.text,
                        mb: 3,
                    }}
                >
                    Crear cuenta
                </Typography>

                {/* PASO 1 */}
                <Collapse in={step === "user"} unmountOnExit mountOnEnter>
                    <UserRegisterForm
                        onLoadingChange={setRegisteringUser}
                        onSuccess={(u) => {
                            enqueueSnackbar("Usuario registrado correctamente", {
                                variant: "success",
                            });
                            setUserData(u);
                            setStep("client");
                        }}
                    />
                </Collapse>

                {/* PASO 2 */}
                <Collapse in={step === "client"} unmountOnExit mountOnEnter>
                    <ClientCreateForm
                        prefillUser={userData ?? undefined}
                        onLoadingChange={setSavingClient}
                        onSuccess={() => {
                            navigate("/", {
                                state: {
                                    snackbar: {
                                        message:
                                            "Usuario registrado y cliente creado correctamente",
                                        variant: "success",
                                    },
                                },
                            });
                        }}
                    />
                </Collapse>
            </Box>
        </Box>
    );
}
